module.exports = __webpack_public_path__ + "static/lich-d0259813950d3fe6eff3c4a8e1bb0277.jpeg";